import { ClientInfo, Preference } from '../types'

export const SIGNING = 'SIGNING'
export const AUTHORIZED = 'AUTHORIZED'
export const UNAUTHORIZED = 'UNAUTHORIZED'
export const TUTORIAL_LINK_SET_ACTION = 'UTORIAL_LINK_SET_ACTION'
export const LOG_OUT = 'LOG_OUT'
export const UPDATE_STRIPE_ACCOUNT = 'UPDATE_STRIPE_ACCOUNT'

interface SigningAction {
    type: typeof SIGNING
}

interface AuthorizedAction {
    type: typeof AUTHORIZED
    payload: {
        user: ClientInfo
    }
}

interface UnauthorizedAction {
    type: typeof UNAUTHORIZED
    payload: {
        error?: string
    }
}

interface TutorialLinkSetAction {
    type: typeof TUTORIAL_LINK_SET_ACTION
    payload: {
        link: Preference
    }
}

interface LogOutAction {
    type: typeof LOG_OUT
}
interface UpdateStripeAccountAction {
    type: typeof UPDATE_STRIPE_ACCOUNT,
    payload: {
        stripeAccount: string
    }
}

export type ActionType = SigningAction | AuthorizedAction | UnauthorizedAction | TutorialLinkSetAction | LogOutAction | UpdateStripeAccountAction

export class Actions {

    static signing(): SigningAction {
        return {
            type: SIGNING
        }
    }

    static authorize(userData: ClientInfo): AuthorizedAction {
        // console.log('autorize, ', userData)
        return {
            type: AUTHORIZED,
            payload: {
                user: userData
            }
        }
    }

    static unathorize(error?: string): UnauthorizedAction {
        return {
            type: UNAUTHORIZED,
            payload: {
                error: error
            }
        }
    }

    static setTutorialLink(link: Preference): TutorialLinkSetAction {
        // console.log('setTutorialLink, ', link)
        return {
            type: TUTORIAL_LINK_SET_ACTION,
            payload: {
                link: link
            }
        }
    }

    static logOut(): LogOutAction {
        return {
            type: LOG_OUT
        }
    }

    static updateStripeAccount(stripeAccount: string): UpdateStripeAccountAction {
        return {
            type: UPDATE_STRIPE_ACCOUNT,
            payload: {
                stripeAccount: stripeAccount
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/signIn.ts